import axios from "axios";

export const API_LC = "https://api.fintech-middleware.leancore.co";
// export const API_LC = "https://api.dev-middleware.leancore.co";
export const FIND_FORM = "/find-form";
export const FIND_ENTITY = "/financial-entity";
export const SUBMIT_FORM = "/create-lead-from-form";
export const UPDATE_USER_FROM_FORM = "/update-user-from-form";
export const SEND_OTP_MESSAGE = "/send-otp-message";
export const LOGIN_OAUTH2 =
  "https://auth.leancore.co/oauth2/token?grant_type=client_credentials";
export const UPLOAD_USER_FILE = "/upload-user-file";
export const BASE_URL = "https://lc.leancore.co";
// export const BASE_URL = "https://dev-lc.leancore.co";
// export const BASE_URL = "https://lc.leancore.co";
export const FIND_USER = "/user-by-nid";

const instance = axios.create({
  baseURL: API_LC,
  timeout: 1000 * 20,
});

export default instance;
